import { defineStore } from 'pinia';
import { reactive } from 'vue';
// 品牌

interface BrandItem {
  brandName?: string;
  brandId: string;
}

export const useBrandStore = defineStore('brand', () => {
  const state = reactive({
    brandName: '', // 品牌名称由登录后的租户信息赋值
    brandId: '111', // 品牌id\
    brandIdType: 'phone', // 注册方式   phone   email
    storeCount: 2, // 门店数量 store_count = 1 → 单店体验   store_count > 1 → 连锁体验
    shopRefresh: false,
  });

  const setBrandFn = (data: BrandItem) => {
    state.brandName = data.brandName;
    state.brandId = data.brandId;
  };

  return {
    state,
    setBrandFn,
  };
});
